module.exports = require('./src/redux-persist-cookie-storage');
